var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 503.997,
    height: 488.841,
    viewBox: "0 0 503.997 488.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lawfirm_1",
    "data-name": "lawfirm 1",
    transform: "translate(-98.003 -35.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M350.25,463.45V71.17a18.328,18.328,0,1,0-12.2,0V463.44a158.57,158.57,0,0,0-119.12,60.977H469.4a158.674,158.674,0,0,0-119.14-60.973Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M515.24,127.23a6.108,6.108,0,0,1-6.109,6.109H179.161a6.109,6.109,0,1,1,0-12.219h329.97A6.108,6.108,0,0,1,515.24,127.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M284.73,364.84l-97.77-232.2-1.691.711-1.719-.633L98,364.918l.262.1c21.656,33.438,55.305,54.918,93.094,54.918,37.824,0,71.5-21.52,93.152-55Zm-182.77-.047,83.422-226.45,95.352,226.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M602,364.84l-97.77-232.2-1.7.711-1.719-.633-85.547,232.2.262.1c21.656,33.438,55.3,54.918,93.094,54.918,37.824,0,71.5-21.52,93.152-55Zm-182.78-.047,83.422-226.45,95.344,226.45Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg20);
export default __webpack_public_path__ + "static/media/20.70e18e21852da02bba7e28106f1bc8c6.svg";
export { ForwardRef as ReactComponent };